module.exports = __webpack_public_path__ + "3a20a43ccd887c47127482c263aa5019.png";